import './style.css'
import * as dat from 'lil-gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import gsap from 'gsap'
// import studio from '@theatre/studio'
import { getProject, types, onChange } from '@theatre/core'

// Initialize the studio
// studio.initialize()
// Create a project for the animation
const project = getProject('THREE.js x Theatre.js', {state})
const sheet = project.sheet('Animated scene')
let cupcakeObjectSheet
import state from './state.json'


document.getElementById("continue-button").addEventListener("click", (event) => {
    console.log("onlick")
    if (sheet.sequence.position >= 0 && sheet.sequence.position < 2.99) {
        sheet.sequence.play({ range: [0, 2.99] })
    } else if (sheet.sequence.position >= 2.99 && sheet.sequence.position < 6.99) {
        sheet.sequence.play({ range: [3, 6.99] })
    } else if (sheet.sequence.position >= 6.99 && sheet.sequence.position < 10.99) {
        sheet.sequence.play({ range: [7, 10.99] })
    } else if (sheet.sequence.position >= 10.99 && sheet.sequence.position < 14.5) {
        sheet.sequence.play({ range: [11, 15] })
        document.getElementById("continue-button").style.display = "none"
    }
}, false);
window.addEventListener("wheel", (event) => {
    console.log("event")
    console.log(event)
    if (sheet.sequence.position >= 0 && sheet.sequence.position < 2.99) {
        sheet.sequence.play({ range: [0, 2.99] })
    } else if (sheet.sequence.position >= 2.99 && sheet.sequence.position < 6.99) {
        sheet.sequence.play({ range: [3, 6.99] })
    } else if (sheet.sequence.position >= 6.99 && sheet.sequence.position < 10.99) {
        sheet.sequence.play({ range: [7, 10.99] })
    } else if (sheet.sequence.position >= 10.99 && sheet.sequence.position < 14.5) {
        sheet.sequence.play({ range: [11, 15] })
        document.getElementById("continue-button").style.display = "none"
    }
})

onChange(sheet.sequence.pointer.position, (position) => {
    console.log('Position of the sequence changed to:', position)
    // if (position.toFixed(2) > 2.99 && )
})


// Debug
const debugObject = {}
/* const gui = new dat.GUI({
    width: 400
}) */

// Canvas
const canvas = document.querySelector('canvas.webgl')
// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color(0xffffff)
const ambientLight = new THREE.AmbientLight(0xffffff, 1)
scene.add(ambientLight)

// first text
// Courier
// Tahoma
const fontName = "Helvetica";
let string = "Awesome...\nSWEETS\nHERE!";
let string2 = "The Best Attention...\nRIGHT\nHERE!";
let string3 = "FEELS \nLIKE\nHOME!";
let string4 = "RUN!   ";
const textureFontSize = 80;
const textureFontSize2 = 160;
let textCanvas = document.createElement("canvas");
let textCanvas2 = document.createElement("canvas");
let textCanvas3 = document.createElement("canvas");
let textCanvas4 = document.createElement("canvas");
textCanvas.width = textCanvas.height = 0;
textCanvas2.width = textCanvas2.height = 0;
textCanvas3.width = textCanvas3.height = 0;
textCanvas4.width = textCanvas4.height = 0;
let textCtx = textCanvas.getContext("2d");
let textCtx2 = textCanvas2.getContext("2d");
let textCtx3 = textCanvas3.getContext("2d");
let textCtx4 = textCanvas4.getContext("2d");
let conesGlobal = undefined

// LOADERS
// Draco loader
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('draco/')
// GLTF loader
const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

// ANIMATIONS
let mixerCandyStore = null
let mixerKitchen = null
let mixerMangaPanel = null
let mixerRunningGuy = null

var groupCupcake = new THREE.Group();
var focusArrows = new THREE.Group();
groupCupcake.renderOrder = 2;
scene.renderOrder = 4
var groupTextCupcake = new THREE.Group();
groupTextCupcake.renderOrder = 2;

gltfLoader.load(
    '/manga/manga/candyStore.glb ',
    // '/manga/candyStore.glb ',
    (gltf) => {
        console.log('gltf candyStore')
        console.log(gltf)
        scene.add(gltf.scene)
        gltf.scene.scale.set(0.1, 0.11, 0.09)
        gltf.scene.rotation.z = Math.PI * 0.5
        gltf.scene.position.z = -0.4
        gltf.scene.position.x = 0.81
        gltf.scene.position.y = -0.03
        mixerCandyStore = new THREE.AnimationMixer(gltf.scene)
        let animationArray = gltf.animations
        animationArray.forEach((animation) => {
            const action = mixerCandyStore.clipAction(animation)
            action.play()
        })
    }
)

gltfLoader.load(
    '/manga/manga/lowPolyKitchen.glb ',
    // '/manga/lowPolyKitchen.glb ',
    (gltf) => {
        scene.add(gltf.scene)
        gltf.scene.scale.set(0.1, 0.1, 0.1)
        gltf.scene.position.z = -0.5
        gltf.scene.position.x = 1.25
        gltf.scene.position.y = -0.34
        /*         mixer = new THREE.AnimationMixer(gltf.scene)
                let animationArray = gltf.animations
                animationArray.forEach( (animation) => {
                    const action = mixer.clipAction(animation)
                    action.play()
                }) */
    }
)

gltfLoader.load(
    '/manga/manga/mangaPanel.glb ',
    // '/manga/mangaPanel.glb ',
    (gltf) => {
        scene.add(gltf.scene)
        gltf.scene.scale.set(1, 1, 1)
        gltf.scene.position.z = 0.15
        gltf.scene.position.y = 0.39

        // Cube background for first box
        let stencilRef = 1
        const planeGeom = new THREE.PlaneGeometry();
        const stencilMat = new THREE.MeshPhongMaterial({ color: 'purple' });
        stencilMat.depthWrite = false;
        stencilMat.stencilWrite = true;
        stencilMat.stencilRef = stencilRef;
        stencilMat.stencilFunc = THREE.AlwaysStencilFunc;
        stencilMat.stencilZPass = THREE.ReplaceStencilOp;
        const stencilMesh = new THREE.Mesh(planeGeom, stencilMat);
        stencilMesh.rotation.x = -Math.PI * 0.5;
        stencilMesh.rotation.y = 0;
        stencilMesh.rotation.z = 0;
        stencilMesh.scale.multiplyScalar(0.85);
        stencilMesh.renderOrder = 1
        scene.add(stencilMesh);
        stencilMesh.position.x = 0.44
        stencilMesh.position.y = 0.38
        stencilMesh.position.z = -1.30


        // get the children that says cone and make larger (scale), and see how it looks like
        let cones = gltf.scene.children.filter((child) => child.name.includes("Cone"))
        conesGlobal = cones

        // cupcake
        let groupCupcakeCylinders = gltf.scene.children.filter((child) => child.name.includes("Cylinder"))
        groupCupcakeCylinders.forEach((son) => { groupCupcake.add(son) })
        let cakeChild = gltf.scene.children.filter((child) => child.name.includes("cake"))
        cakeChild.forEach((son) => { groupCupcake.add(son) })
        let cherry = gltf.scene.children.filter((child) => child.name.includes("cherry"))
        cherry.forEach((son) => { groupCupcake.add(son) })
        let cherry2 = gltf.scene.children.filter((child) => child.name.includes("cherry001"))
        cherry2.forEach((son) => { groupCupcake.add(son) })
        let cream = gltf.scene.children.filter((child) => child.name.includes("cream"))
        cream.forEach((son) => { groupCupcake.add(son) })
        let cup = gltf.scene.children.filter((child) => child.name.includes("cup"))
        cup.forEach((son) => { groupCupcake.add(son) })

        mixerMangaPanel = new THREE.AnimationMixer(gltf.scene)
        let animationArray = gltf.animations
        animationArray.forEach((animation) => {
            const action = mixerMangaPanel.clipAction(animation)
            action.play()
        })

        // TODO make in another glb file ?
        // stencil for cupcake
        if (groupCupcake.children.length > 0) {
            groupCupcake.children.forEach((cupcakeChildMesh) => {
                var skinnedMesh = cupcakeChildMesh;
                const prevMat = skinnedMesh.material;
                skinnedMesh.material = new THREE.MeshBasicMaterial().copy(prevMat);
                skinnedMesh.material.map = prevMat.map;
                skinnedMesh.material.stencilWrite = true;
                skinnedMesh.material.stencilRef = 1;
                skinnedMesh.material.stencilFunc = THREE.EqualStencilFunc;
                skinnedMesh.material.stencilFuncMask = 0xFF;
                skinnedMesh.material.stencilZPass = THREE.ReplaceStencilOp;
                skinnedMesh.material.stencilZPass = THREE.ReplaceStencilOp;
                skinnedMesh.material.needsUpdate = true;
            })
            groupCupcake.position.x = 3.3775
            groupCupcake.position.y = -3.1412
            groupCupcake.position.z = 1.1611
            groupCupcake.rotation.z = 0.9004
            cupcakeObjectSheet = sheet.object('cupcake', {
                // (full rotation: 2 * Math.PI)
                position: types.compound({
                    x: types.number(groupCupcake.position.x, { range: [-4, 4] }),
                    y: types.number(groupCupcake.position.y, { range: [-4, 4] }),
                    z: types.number(groupCupcake.position.z, { range: [-4, 4] }),
                }),
                rotation: types.compound({
                    x: types.number(groupCupcake.rotation.x, { range: [-4, 4] }),
                    y: types.number(groupCupcake.rotation.y, { range: [-4, 4] }),
                    z: types.number(groupCupcake.rotation.z, { range: [-4, 4] }),
                }),
            })

            cupcakeObjectSheet.onValuesChange((values) => {
                groupCupcake.position.x = values.position.x
                groupCupcake.position.y = values.position.y
                groupCupcake.position.z = values.position.z
                groupCupcake.rotation.x = values.rotation.x
                groupCupcake.rotation.y = values.rotation.y
                groupCupcake.rotation.z = values.rotation.z
            })
        }
        gltf.scene.renderOrder = 3;
        scene.add(groupCupcake)

        // focus arrows
        conesGlobal.forEach((cone) => focusArrows.add(cone))
        focusArrows.position.z = 0.15
        focusArrows.position.y = 0.4
        scene.add(focusArrows)
    }
)

gltfLoader.load(
    '/manga/manga/runningGuy.glb ',
    // '/manga/runningGuy.glb ',
    (gltf) => {
        scene.add(gltf.scene)
        gltf.scene.scale.set(0.5, 0.5, 0.5)
        gltf.scene.position.z = -1.265
        gltf.scene.position.x = 1.18
        gltf.scene.position.y = -0.37
        mixerRunningGuy = new THREE.AnimationMixer(gltf.scene)
        let animationArray = gltf.animations
        const action = mixerRunningGuy.clipAction(animationArray[0])
        action.enable = true
        action.play()
    }
)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 100)
scene.add(camera)

let cameraObjectSheet = sheet.object('camera', {
    // (full rotation: 2 * Math.PI)
    position: types.compound({
        x: types.number(0, { range: [0, 2] }),
        y: types.number(0, { range: [0, 10] }),
        z: types.number(0, { range: [-2, 2] }),
    }),
    rotation: types.compound({
        x: types.number(0, { range: [-2, 1] }),
        y: types.number(0, { range: [-1, 1] }),
        z: types.number(0, { range: [0, 2] }),
    }),
})

cameraObjectSheet.onValuesChange((values) => {
    camera.position.x = values.position.x
    camera.position.y = values.position.y
    camera.position.z = values.position.z
    camera.rotation.x = values.rotation.x
    camera.rotation.y = values.rotation.y
    camera.rotation.z = values.rotation.z
})

scene.background = new THREE.Color('skyblue');
// Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.outputEncoding = THREE.sRGBEncoding
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () => {
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    if (mixerCandyStore) {
        mixerCandyStore.update(deltaTime)
    }
    if (mixerMangaPanel) {
        mixerMangaPanel.update(deltaTime)
    }
    if (mixerRunningGuy) {
        mixerRunningGuy.update(deltaTime)
    }

    if (conesGlobal !== undefined) {
        conesGlobal.forEach(element => {
            let temp = Math.floor(Math.random() * (1 - 0 + 1)) + 0
            if (temp == 0) {
                element.visible = false
            } else {
                element.visible = true
            }
        });
    }

    // LINE code
    // drawCount = ( drawCount + 0.00001 ) % MAX_POINTS;
    // drawCount = drawCount + 0.1
    // line.geometry.setDrawRange(0, drawCount);
    // if (drawCount === 0) {
    //        line.geometry.attributes.position.needsUpdate = true; // required after the first render
    //    }

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

// ---------------------------------------------------------------
// Handle texture plane
const createPlaneForText = () => {
    // Parse text
    const lines = string.split(`\n`);
    const linesMaxLength = [...lines].sort((a, b) => b.length - a.length)[0]
        .length;
    const wTexture = textureFontSize * 0.6 * linesMaxLength;
    const hTexture = lines.length * textureFontSize;

    // Draw text
    const linesNumber = lines.length;
    textCanvas.width = wTexture;
    textCanvas.height = hTexture;
    textCtx.font = "100 " + textureFontSize + "px " + fontName;
    textCtx.fillStyle = "#ffffff";
    textCtx.clearRect(0, 0, textCanvas.width, textCanvas.height);
    for (let i = 0; i < linesNumber; i++) {
        textCtx.fillText(lines[i], 0, ((i + 0.8) * hTexture) / linesNumber);
    }
    const texture = new THREE.CanvasTexture(textCanvas);
    const planeGeometry = new THREE.PlaneGeometry(
        textCanvas.width,
        textCanvas.height
    );
    const planeMaterial1 = new THREE.MeshStandardMaterial({
        map: texture,
        opacity: 0,
        transparent: true
    });
    
    groupTextCupcake.position.x = 0.77
    groupTextCupcake.position.y = 0.2485
    groupTextCupcake.position.z = -1.5767
    groupTextCupcake.rotation.x = 1.5523
    groupTextCupcake.rotation.y = 2.856
    groupTextCupcake.rotation.z = -1.5767
    const planeMesh = new THREE.Mesh(planeGeometry, planeMaterial1);
    // text position
    planeMesh.material.stencilWrite = true;
    planeMesh.material.stencilRef = 1;
    planeMesh.material.stencilFunc = THREE.EqualStencilFunc;
    planeMesh.material.stencilFuncMask = 0xFF;
    planeMesh.material.stencilZPass = THREE.ReplaceStencilOp;
    planeMesh.material.stencilZPass = THREE.ReplaceStencilOp;
    planeMesh.material.needsUpdate = true;
    planeMesh.scale.multiplyScalar(0.0005)
    groupTextCupcake.add(planeMesh);
    scene.add(groupTextCupcake)

    let textPanel1ObjectSheet = sheet.object('textPanel1', {
        // (full rotation: 2 * Math.PI)
        position: types.compound({
            x: types.number(groupTextCupcake.position.x, { range: [-4, 4] }),
            y: types.number(groupTextCupcake.position.y, { range: [-4, 4] }),
            z: types.number(groupTextCupcake.position.z, { range: [-4, 4] }),
        }),
        rotation: types.compound({
            x: types.number(groupTextCupcake.rotation.x, { range: [-4, 4] }),
            y: types.number(groupTextCupcake.rotation.y, { range: [-4, 4] }),
            z: types.number(groupTextCupcake.rotation.z, { range: [-4, 4] }),
        }),
        visible: types.boolean(false),
    })
    
    let lastValueForVisible = false
    textPanel1ObjectSheet.onValuesChange((values) => {
        console.log('textPanel1ObjectSheet')
        console.log(sheet.sequence.position)
        console.log('values')
        console.log(values)
        groupTextCupcake.position.x = values.position.x
        groupTextCupcake.position.y = values.position.y
        groupTextCupcake.position.z = values.position.z
        groupTextCupcake.rotation.x = values.rotation.x
        groupTextCupcake.rotation.y = values.rotation.y
        groupTextCupcake.rotation.z = values.rotation.z
        // TODO turn off later?
        // groupTextCupcake.visible
        if (lastValueForVisible != values.visible) {
            lastValueForVisible = values.visible
            if (values.visible === true)
                gsap.to(planeMaterial1, { duration: 1, opacity: 1 })
            else
                gsap.to(planeMaterial1, { duration: 1, opacity: 0 })
        }
    })
}


// Handle texture plane
const createPlaneForText2 = () => {
    // Parse text
    const lines = string2.split(`\n`);
    const linesMaxLength = [...lines].sort((a, b) => b.length - a.length)[0]
        .length;
    const wTexture = textureFontSize * 0.6 * linesMaxLength;
    const hTexture = lines.length * textureFontSize;

    // Draw text
    const linesNumber = lines.length;
    textCanvas2.width = wTexture;
    textCanvas2.height = hTexture;
    textCtx2.font = "100 " + textureFontSize + "px " + fontName;
    textCtx2.fillStyle = "#ffffff";
    textCtx2.clearRect(0, 0, textCanvas2.width, textCanvas2 .height);
    for (let i = 0; i < linesNumber; i++) {
        textCtx2.fillText(lines[i], 0, ((i + 0.8) * hTexture) / linesNumber);
    }
    const texture = new THREE.CanvasTexture(textCanvas2);
    const planeGeometry = new THREE.PlaneGeometry(
        textCanvas2.width,
        textCanvas2.height
    );
    const planeMaterial2 = new THREE.MeshStandardMaterial({
        map: texture,
        opacity: 0,
        transparent: true
    });

    const planeMesh2 = new THREE.Mesh(planeGeometry, planeMaterial2);
    // text position
    planeMesh2.scale.multiplyScalar(0.0005)
    planeMesh2.position.x = 0.2030325450214913
    planeMesh2.position.y = 0.2
    planeMesh2.position.z = -0.2
    planeMesh2.rotation.x = 0.7082396441733496
    planeMesh2.rotation.y = -3.240606509004299
    planeMesh2.rotation.z = -1.4180621306146162
    scene.add(planeMesh2)

    let textPanel2ObjectSheet = sheet.object('textPanel2', {
        // (full rotation: 2 * Math.PI)
        position: types.compound({
            x: types.number(planeMesh2.position.x, { range: [-4, 4] }),
            y: types.number(planeMesh2.position.y, { range: [-4, 4] }),
            z: types.number(planeMesh2.position.z, { range: [-4, 4] }),
        }),
        rotation: types.compound({
            x: types.number(planeMesh2.rotation.x, { range: [-4, 4] }),
            y: types.number(planeMesh2.rotation.y, { range: [-4, 4] }),
            z: types.number(planeMesh2.rotation.z, { range: [-4, 4] }),
        }),
        visible: types.boolean(false),
    })
    
    let lastValueForVisible = false
    textPanel2ObjectSheet.onValuesChange((values) => {
        console.log('textPanel1ObjectSheet')
        console.log(sheet.sequence.position)
        console.log('values')
        console.log(values)
        planeMesh2.position.x = values.position.x
        planeMesh2.position.y = values.position.y
        planeMesh2.position.z = values.position.z
        planeMesh2.rotation.x = values.rotation.x
        planeMesh2.rotation.y = values.rotation.y
        planeMesh2.rotation.z = values.rotation.z

        if (lastValueForVisible != values.visible) {
            lastValueForVisible = values.visible
            if (values.visible === true)
                gsap.to(planeMaterial2, { duration: 1, opacity: 1 })
            else
                gsap.to(planeMaterial2, { duration: 1, opacity: 0 })
        }
    })
}

// Handle texture plane
const createPlaneForText3 = () => {
    // Parse text
    const lines = string3.split(`\n`);
    const linesMaxLength = [...lines].sort((a, b) => b.length - a.length)[0]
        .length;
    const wTexture = textureFontSize * 0.6 * linesMaxLength;
    const hTexture = lines.length * textureFontSize;

    // Draw text
    const linesNumber = lines.length;
    textCanvas3.width = wTexture;
    textCanvas3.height = hTexture;
    textCtx3.font = "100 " + textureFontSize + "px " + fontName;
    textCtx3.fillStyle = "#ffffff";
    textCtx3.clearRect(0, 0, textCanvas3.width, textCanvas3 .height);
    for (let i = 0; i < linesNumber; i++) {
        textCtx3.fillText(lines[i], 0, ((i + 0.8) * hTexture) / linesNumber);
    }
    const texture = new THREE.CanvasTexture(textCanvas3);
    const planeGeometry = new THREE.PlaneGeometry(
        textCanvas3.width,
        textCanvas3.height
    );
    const planeMaterial3 = new THREE.MeshStandardMaterial({
        map: texture,
        opacity: 1,
        transparent: true
    });

    const planeMesh3 = new THREE.Mesh(planeGeometry, planeMaterial3);
    // text position
    planeMesh3.scale.multiplyScalar(0.0005)
    planeMesh3.position.x = 0.2030325450214913
    planeMesh3.position.y = 0.2
    planeMesh3.position.z = -0.2
    planeMesh3.rotation.x = 0.7082396441733496
    planeMesh3.rotation.y = -3.240606509004299
    planeMesh3.rotation.z = -1.4180621306146162
    scene.add(planeMesh3)

    let textPanel3ObjectSheet = sheet.object('textPanel3', {
        // (full rotation: 2 * Math.PI)
        position: types.compound({
            x: types.number(planeMesh3.position.x, { range: [-4, 4] }),
            y: types.number(planeMesh3.position.y, { range: [-4, 4] }),
            z: types.number(planeMesh3.position.z, { range: [-4, 4] }),
        }),
        rotation: types.compound({
            x: types.number(planeMesh3.rotation.x, { range: [-4, 4] }),
            y: types.number(planeMesh3.rotation.y, { range: [-4, 4] }),
            z: types.number(planeMesh3.rotation.z, { range: [-4, 4] }),
        }),
        visible: types.boolean(false),
    })
    
    let lastValueForVisible = false
    textPanel3ObjectSheet.onValuesChange((values) => {
        console.log('textPanel3ObjectSheet')
        console.log(sheet.sequence.position)
        console.log('values')
        console.log(values)
        planeMesh3.position.x = values.position.x
        planeMesh3.position.y = values.position.y
        planeMesh3.position.z = values.position.z
        planeMesh3.rotation.x = values.rotation.x
        planeMesh3.rotation.y = values.rotation.y
        planeMesh3.rotation.z = values.rotation.z

        if (lastValueForVisible != values.visible) {
            lastValueForVisible = values.visible
            if (values.visible === true)
                gsap.to(planeMaterial3, { duration: 1, opacity: 1 })
            else
                gsap.to(planeMaterial3, { duration: 1, opacity: 0 })
        }
    })
}

// Handle texture plane
const createPlaneForText4 = () => {
    // Parse text
    const lines = string4.split(`\n`);
    const linesMaxLength = [...lines].sort((a, b) => b.length - a.length)[0]
        .length;
    const wTexture = textureFontSize2 * 0.6 * linesMaxLength;
    const hTexture = lines.length * textureFontSize2;

    // Draw text
    const linesNumber = lines.length;
    textCanvas4.width = wTexture;
    textCanvas4.height = hTexture;
    textCtx4.font = "100 " + textureFontSize2 + "px " + fontName;
    textCtx4.fillStyle = "#ffffff";
    textCtx4.clearRect(0, 0, textCanvas4.width, textCanvas4 .height);
    for (let i = 0; i < linesNumber; i++) {
        textCtx4.fillText(lines[i], 0, ((i + 0.8) * hTexture) / linesNumber);
    }
    const texture = new THREE.CanvasTexture(textCanvas4);
    const planeGeometry = new THREE.PlaneGeometry(
        textCanvas4.width,
        textCanvas4.height
    );
    const planeMaterial4 = new THREE.MeshStandardMaterial({
        map: texture,
        opacity: 0,
        transparent: true
    });

    const planeMesh4 = new THREE.Mesh(planeGeometry, planeMaterial4);
    // text position
    planeMesh4.scale.multiplyScalar(0.0005)
    planeMesh4.position.x = 0.2030325450214913
    planeMesh4.position.y = 0.2
    planeMesh4.position.z = -0.2
    planeMesh4.rotation.x = 0.7082396441733496
    planeMesh4.rotation.y = -3.240606509004299
    planeMesh4.rotation.z = -1.4180621306146162
    scene.add(planeMesh4)

    let textPanel4ObjectSheet = sheet.object('textPanel4', {
        // (full rotation: 2 * Math.PI)
        position: types.compound({
            x: types.number(planeMesh4.position.x, { range: [-4, 4] }),
            y: types.number(planeMesh4.position.y, { range: [-4, 4] }),
            z: types.number(planeMesh4.position.z, { range: [-4, 4] }),
        }),
        rotation: types.compound({
            x: types.number(planeMesh4.rotation.x, { range: [-4, 4] }),
            y: types.number(planeMesh4.rotation.y, { range: [-4, 4] }),
            z: types.number(planeMesh4.rotation.z, { range: [-4, 4] }),
        }),
        visible: types.boolean(false),
    })
    
    let lastValueForVisible = false
    textPanel4ObjectSheet.onValuesChange((values) => {
        console.log('textPanel4ObjectSheet')
        console.log(sheet.sequence.position)
        console.log('values')
        console.log(values)
        planeMesh4.position.x = values.position.x
        planeMesh4.position.y = values.position.y
        planeMesh4.position.z = values.position.z
        planeMesh4.rotation.x = values.rotation.x
        planeMesh4.rotation.y = values.rotation.y
        planeMesh4.rotation.z = values.rotation.z

        if (sheet.sequence.position > 14.5) {
            console.log("INSIDE")
            sheet.sequence.position = 13.5
            sheet.sequence.play()
        }
        if (lastValueForVisible != values.visible) {
            lastValueForVisible = values.visible
            if (values.visible === true)
                gsap.to(planeMaterial4, { duration: 1, opacity: 1 })
            else
                gsap.to(planeMaterial4, { duration: 1, opacity: 0 })
        }
    })
}

// LINE
const drawLine = () => {

    const MAX_POINTS = 5000;

    // geometry
    const geometry = new THREE.BufferGeometry();

    // attributes
    const positions = new Float32Array(MAX_POINTS * 3); // 3 vertices per point
    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

    // drawcalls
    let drawCount = 2; // draw the first 2 points, only
    geometry.setDrawRange(0, 2);

    // material
    // const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
    const material = new THREE.LineDashedMaterial({
        color: 0xffffff,
        linewidth: 1,
        scale: 0.001,
        dashSize: 0.001,
        gapSize: 0.001,
    })

    let line = new THREE.Line(geometry, material);
    const positions2 = line.geometry.attributes.position.array;

    let index = 0;

    for (let g = 0; g < MAX_POINTS; g = g + 3) {
        //console.log(g)
        positions2[g] = index;
        positions2[g + 1] = 0;
        positions2[g + 2] = 0;
        index = index + 0.1
    }
    // scene.add(line);
}
    // END LINE
    createPlaneForText() 
    createPlaneForText2()
    createPlaneForText3()
    createPlaneForText4()
    tick()